clickedOverlay